import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { modeSchema } from '@apps/web/lib/mode_store';

export const Route = createFileRoute('/_app/admin/agent-traces/run/$runId')({
    validateSearch: z.object({ mode: modeSchema.optional() }),
    head: () => ({ meta: [{ title: 'Agent Run Trace' }] }),
});
